
import Vue from 'vue';
import { Data as ArticleData } from '@root/modules/article/types/article';
import rootConfig from '@root/config/root.config';
import PianoCustomerStateHandler from '@piano/components/PianoCustomerStateHandler.vue';
import { faAngleRight } from '@delfi.lt/fa-kit/icons/modules/classic/solid';

interface Props {
  article: ArticleData;
  size: string;
}

interface Computed {
  disableLogin: boolean;
  isPressPelease: boolean;
  isPtContent: boolean;
  isRegistered: boolean;
  isPoliticalAd: boolean;
}

interface Methods {
  scrollToPaywall: () => void;
  scrollToRegwall: () => void;
}

export default Vue.extend<unknown, unknown, Computed, Props, Methods>({
  components: {
    PianoCustomerStateHandler,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      faAngleRight,
    };
  },
  computed: {
    disableLogin() {
      const { specialFeatures } = this.$channelConfig('settings').application || {};
      return rootConfig.disableLogin || !!this.$channelConfig('settings').disableLogin || specialFeatures?.hideSignupAndOrders?.enabled;
    },
    isPressPelease() {
      const settings: any = this.article.settings;
      return !!settings['icon.press_release'] || !!settings['frontPagePressRelease'];
    },
    isPoliticalAd() {
      const settings: any = this.article.settings;
      return !!settings['frontPagePoliticalAd'];
    },
    isPtContent() {
      const settings: any = this.article.settings;
      return (
        (!!settings['icon.reklama'] ||
          !!settings['frontPageSponsoredContent'] ||
          this.article.primaryCategory.channel.url === 'www.delfi.lt/uzsakomasis-turinys') &&
        !settings['frontPageSupportedContent']
      );
    },
    isRegistered() {
      return this.article.settings?.isRegistered ?? false;
    },
  },
  methods: {
    scrollToPaywall() {
      this.$event.send('link-click', { name: this.$t('words.subscribe'), type: `article-info-tags` });

      const paywall = document.querySelector(`#article-${this.article.id} .article-paywall`) as HTMLElement;
      paywall.scrollIntoView({ behavior: 'smooth' });
    },
    scrollToRegwall() {
      const regwall = document.querySelector(`#article-${this.article.id} .article-regwall`) as HTMLElement;
      regwall.scrollIntoView({ behavior: 'smooth', block: 'center' });
    },
  },
});
